module.exports = __webpack_public_path__ + "static/media/Goway_main.f8701a72.svg";